<div class="header">
    <div class="header-logo">
        <i *ngIf="!menuToggle" class="bi bi-chevron-double-left desktop-menu-btn" title="Close Side Menu" (click)="toggleMenu()"></i>
        <i *ngIf="menuToggle" class="bi bi-chevron-double-right desktop-menu-btn" title="Open Side Menu" (click)="toggleMenu()"></i>
        <i class="bi bi-list mobile-menu-btn" title="Toggle Menu" (click)="toggleMenu()"></i>
        <img src="{{header_logo}}" class="logo logo-scrolled" alt="">
        <p class="header-logo-text">{{header_logo_name}}</p>
    </div>
    <div class="logout-block">
        <!-- <i class="bi bi-lightbulb-fill"></i> -->

        <i class="bi bi-question-circle" title="Help" routerLink="help" routerLinkActive="active"></i>
        <!-- <i class="bi bi-info-circle" routerLink="help" routerLinkActive="active"></i> -->
        <div class="notification-block">
            <div (click)="notificationShowOrHideToggle()" class="notification-bell">
                <i class="bi bi-bell-fill" title="Notification"></i>
                <p-badge *ngIf="notificationDataCount != 0" badgeSize="xlarge" severity="success"
                    value="{{notificationDataCount}}"></p-badge>
            </div>

            <!-- <i (click)="notificationShowOrHideToggle()" class="pi pi-bell text-3xl" style="font-size: 2rem" pBadge value="2"></i> -->

            <div class="notification-list" *ngIf="notificationBlockToggle">
                <div class="notification-header">
                    <p>Notifications</p>
                </div>

                <div class="notification-unread">
                    <p [ngClass]="{'p-active': notificationReadToggle == 'unread'}"
                        (click)="notificationReadUnReadToggle(false)">Unread</p>
                    <p [ngClass]="{'p-active': notificationReadToggle == 'read'}"
                        (click)="notificationReadUnReadToggle(true)">Read</p>
                </div>

                <div class="list-block">
                    <div *ngIf="!isLoading">
                        <div class="list" *ngFor="let list of notificationData">
                            <div class="message">
                                <p (click)="viewTicket(list.ticketId)">{{list.message}}</p>
                                <!-- <p class="ticket-id" (click)="viewTicket(list.ticketId)">{{list.ticketId}}</p> -->

                                <i *ngIf="!notificationReadStatus" (click)="updateReadStatus(true,list.notificationId)"
                                    class="bi bi-x-lg"></i>

                            </div>
                            <div class="dates">
                                <p class="recieved">
                                    recieved on: <span>{{list.date | date}}</span></p>
                            </div>
                        </div>

                        <div class="load-more"
                            *ngIf="totalRecords != notificationData.length && notificationData.length != 0">
                            <button (click)="loadMore()">load more</button>
                        </div>
                    </div>


                    <div class="loader" *ngIf="isLoading">
                        <div class="spinner"></div>
                    </div>

                    <div class="loader" *ngIf="!isLoading && notificationData.length == 0">
                        <div class="no-data">
                            <img src="assets/no-data-6.png" alt="">
                            <p>no data found</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <a (click)="logout()"><i class="fa fa-sign-in"></i><span class="logout-text">Sign Out</span></a>
    </div>
</div>